import { render, staticRenderFns } from "./initialIn-add-or-update.vue?vue&type=template&id=61efc156&scoped=true"
import script from "./initialIn-add-or-update.vue?vue&type=script&lang=js"
export * from "./initialIn-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./initialIn-add-or-update.vue?vue&type=style&index=0&id=61efc156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61efc156",
  null
  
)

export default component.exports